<form *ngIf="form" [formGroup]="form" (ngSubmit)="submitForm()">
  <rds-c-variable-select
    formControlName="rows"
    suffixIcon="view_stream"
    [chipsAriaLabel]="maxRows | i18nPlural: { '=1': _selectedRowPlaceholder, other: _selectedRowsPlaceholder }"
    [config]="rowsConfig"
    [disabledOptions]="disabledRowOptions$ | async"
    [maxSelection]="maxRows"
    [multiSelect]="maxRows > 1"
    [options]="variables | rdsIsDimension"
    [orderable]="true"
    [required]="true"
    [selectLabel]="maxRows | i18nPlural: { '=1': _rowLabelPlaceholder, other: _rowsLabelPlaceholder }"
    [selectPlaceholder]="maxRows | i18nPlural: { '=1': _selectARowPlaceholder, other: _selectRowsPlaceholder }"
    (selectionChange)="disabledColumnOptions$.next($event)"
  ></rds-c-variable-select>
  <rds-c-variable-select
    *ngIf="maxColumns > 0"
    formControlName="columns"
    suffixIcon="view_column"
    [chipsAriaLabel]="maxRows | i18nPlural: { '=1': _selectedColumnPlaceholder, other: _selectedColumnsPlaceholder }"
    [config]="columnsConfig"
    [disabledOptions]="disabledColumnOptions$ | async"
    [maxSelection]="maxColumns"
    [multiSelect]="maxColumns > 1"
    [options]="variables | rdsIsDimension"
    [orderable]="true"
    [selectLabel]="maxColumns | i18nPlural: { '=1': _columnPlaceholder, other: _columnsPlaceholder }"
    [selectPlaceholder]="maxColumns | i18nPlural: { '=1': _selectAColumnPlaceholder, other: _selectColumnsPlaceholder }"
    (selectionChange)="disabledRowOptions$.next($event)"
  ></rds-c-variable-select>
  <mat-divider></mat-divider>

  <rds-c-measure-select
    formControlName="measures"
    suffixIcon="square_foot"
    [config]="measureConfig"
    [types]="!!measureVariables ? _allMeasureTypes : _countAndPercentMeasureTypes"
    [variables]="measureVariables"
  ></rds-c-measure-select>
  <mat-divider></mat-divider>

  <rds-c-filter-select
    formControlName="filters"
    [config]="filterConfig"
    [dialogFilterStyles]="dialogFilterStyles"
    [dialogMinWidth]="dialogMinWidth"
    [multiSelect]="multiFilterCodes"
    [multiVariableSelect]="multiFilterVariables"
    [supportedOperators]="supportedOperators"
    [variables]="variables"
  ></rds-c-filter-select>

  <rds-c-variable-select
    *ngIf="weightedVariables?.length"
    i18n-chipsAriaLabel
    chipsAriaLabel="Selected Weights"
    formControlName="weights"
    i18n-selectLabel
    selectLabel="Weight(s)"
    i18n-selectPlaceholder
    selectPlaceholder="Select weights..."
    suffixIcon="fitness_center"
    [config]="weightsConfig"
    [options]="weightedVariables"
  ></rds-c-variable-select>

  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" class="dimension-selection-btns">
    <button
      [disabled]="!form.dirty && _isFormEmpty"
      mat-icon-button
      aria-label="Reset values"
      matTooltip="Reset values"
      class="reset-form-button"
      i18n-aria-label
      i18n-matTooltip
      type="button"
      (click)="resetForm()"
    >
      <mat-icon>autorenew</mat-icon>
    </button>
    <mtna-extended-fab fxFlex class="tabulate-button" color="accent" [disabled]="tabulating">
      <mat-spinner *ngIf="tabulating; else notTabulating" color="accent" [diameter]="24"></mat-spinner>
      <ng-template #notTabulating i18n>TABULATE</ng-template>
    </mtna-extended-fab>
  </div>
</form>
